import React, { Component, Fragment, cloneElement } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { Typo, Icon, Modal, Form } from 'tmt-ui-kit';

import Link from '~/components/Link/Link';
import { path, defaultAvatarImage } from '~/utils/media';
import config from '~/config';

const Container = styled.div`
  width: 100%;
  background-color: ${props => props.theme.blueGrayLighter};
  display: flex;
  padding: 16px;
  justify-content: space-between;
  border-radius: 6px;
  @media(max-width: 600px) {
    margin-left: -16px;
    margin-right: -16px;
    width: initial;
    flex-direction: row;
    border-radius: 0;
  }
  @media screen and (device-aspect-ratio: 40/71) {
    flex-direction: column;
  }
`;

const NameBox = styled.div`
  display: flex;
`;

const AwardImageContainer = styled.div`
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 8px;
`;

const AwardImage = styled.img`
  display: block;
  width: 29px;
  object-fit: contain;
`;

const ExperiencedBy = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const LocalExperienceBy = styled(Typo.Paragraph)`
  margin: 0;
`;

const SelectLocalExperts = styled(Typo.Paragraph)`
  font-size: 14px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.57 !important;
  letter-spacing: normal;
  color: #16c464 !important;
  margin: 0;
`;

const ImageOval = styled.img`
  width: 18px;
  height: 18px;
  margin: 1px;
  border-radius: 50%;
`;

const LXName = styled(Typo.Paragraph)`
  font-size: 16px !important;
  font-weight: 500 !important;
  color: ${props => (props.isMasterTrip ? props.theme.greenLighter : props.theme.blue)} !important;
  margin: 0;
`;

const LXImageContainer = styled.div`
  padding-right: 8px;
`;

const LXImageBox = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
`;

const SelectLXImageBox = styled.div`
  width: 64px;
  height: 44px;
  overflow: hidden;
`;

const MessageContainer = styled.a`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  @media screen and (device-aspect-ratio: 40/71) {
    justify-content: flex-start;
    padding-top: 8px;
    width: fit-content;
  }
`;

const MessageText = styled(Typo.Regular)`
  margin: 0;
  display: flex;
  font-weight: 500 !important;
  color: ${props => props.theme.blue} !important;
  i {
    margin-right: 4px;
  }
  @media(max-width: 600px) {
    flex-direction: column;
    align-items: center;
  }
  @media screen and (device-aspect-ratio: 40/71) {
    align-items: center;
    flex-direction: row;
  }
`;


const SignatureModal = styled(Modal.PlainModal)`
  width: 640px !important;
  @media(max-width: 600px) {
    width: 100% !important;
  }
`;

const SignatureModalText = styled(Typo.Paragraph)`
  text-align: left;
  margin-bottom: 16px !important;
`;

const SignatureModalTitle = styled(Typo.Medium)`
  text-align: left;
  font-size: 18px !important;
`;

const CloseModalButton = styled(Form.Button.GreenButton)`
  width: 240px;
`;

const SignatureModalImage = styled.img`
  margin: 16px 0;
`;

const getInitialState = () => {
  const imageLX = ['LX1', 'LX2', 'LX3', 'LX4', 'LX5', 'LX6', 'LX7', 'LX8', 'LX9'];
  const imageList = [];
  while (imageList.length < 6) {
    imageList.push(`${imageLX.splice(Math.floor(Math.random() * imageLX.length), 1)}`);
  }
  return { imageList, isShowSignatureLXModal: false };
};

const linkContainerCss = css `
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const LxLink = styled(Link)`
  ${linkContainerCss}
`;

const SelectLXContainer = styled.div`
  ${linkContainerCss}
  cursor: pointer;
`;

const MessageSpan = styled.span`

`;

const MessageIcon = styled(Icon)`
  @media(max-width: 600px) {
    font-size: 30px;
    width: 30px;
    height: 30px;
  }
`;

class LX extends Component {
  state = getInitialState();

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.trip._id !== nextProps.trip._id) {
      return true;
    }
    if (this.state.isShowSignatureLXModal !== nextState.isShowSignatureLXModal) {
      return true;
    }
    return false;
  }

  onToggleSignature = (isShowSignatureLXModal) => {
    this.setState({ isShowSignatureLXModal });
  }

  render() {
    const { trip } = this.props;
    const { staticImagePath } = this.context;
    const { user_id: lx } = trip;
    const { imageList, isShowSignatureLXModal } = this.state;
    const containerElement = trip.is_master_trip
      ? <SelectLXContainer onClick={() => this.onToggleSignature(true)} />
      : <LxLink to={`/local-expert/${trip.user_id.slug}`} />;
    let lxName = `${lx.name.first} ${lx.name.last}`;
    if (lx.is_travel_agency && lx.company_name) {
      lxName = lx.company_name;
    }
    return (
      <Fragment>
        <Container>
          {cloneElement(containerElement, {}, (
            <Fragment>
              <NameBox>
                <LXImageContainer>
                  {
                    trip.is_master_trip ? (
                      <SelectLXImageBox>
                        {
                          imageList.map(image => (
                            <ImageOval
                              src={staticImagePath(`/trips/${image}.png`)}
                              srcSet={`${staticImagePath(`/trips/${image}@2x.png`)} 2x`}
                              alt="Selected Local Experts"
                            />
                          ))
                        }
                      </SelectLXImageBox>
                    ) : (
                      <LXImageBox>
                        <img
                          src={lx.avatar_image ? path(lx.avatar_image, 'avatarNavMini') : defaultAvatarImage(lx.name.first)}
                          srcSet={`${lx.avatar_image ? path(lx.avatar_image, 'avatarNavMini2x') : defaultAvatarImage(lx.name.first, true)} 2x`}
                          alt={lx.name.first}
                        />
                      </LXImageBox>
                    )
                  }
                </LXImageContainer>
                {lx.verification && lx.verification.best_of_badge && !trip.is_master_trip && (
                  <AwardImageContainer>
                    <AwardImage src={staticImagePath('/common/best-of-lx.png')} />
                  </AwardImageContainer>
                )}
                <ExperiencedBy>
                  <LocalExperienceBy>{!lx.is_travel_agency ? 'Local ' : ''}Experience by</LocalExperienceBy>
                  {trip.is_master_trip
                    ? <SelectLocalExperts>Selected Local Experts</SelectLocalExperts>
                    : <LXName>{lxName}</LXName>
                  }
                </ExperiencedBy>
              </NameBox>
            </Fragment>
          ))}
          {!trip.is_message_disabled && (
            <MessageContainer
              onClick={this.props.onRequest}
              href={this.props.messageLink}
              rel="noopener noreferrer nofollow"
            >
              <MessageText>
                <MessageIcon name="message" />
                <MessageSpan>Message</MessageSpan>
              </MessageText>
            </MessageContainer>
          )}
        </Container>
        {trip.is_master_trip && (
          <SignatureModal
            maxWidth={640}
            centerVertical
            isOpen={isShowSignatureLXModal}
            onClose={() => this.onToggleSignature(false)}
          >
            <SignatureModalTitle>Selected Local Experts</SignatureModalTitle>
            <SignatureModalImage
              src={`${config.assetPath}/static/images/TripDetail/icon-select-lx.png`}
              srcSet={`${config.assetPath}/static/images/TripDetail/icon-select-lx@2x.png 2x`}
            />
            <SignatureModalText>You will be assigned one of the Selected Local Experts on TakeMeTour system. Selected Local Experts are our top-rated Local Experts. They possess great service mind and in-depth knowledge of the destinations, as well as the local culture and way of life.</SignatureModalText>
            <CloseModalButton onClick={() => this.onToggleSignature(false)}>Close</CloseModalButton>
          </SignatureModal>
        )}
      </Fragment>
    );
  }
}

LX.contextTypes = {
  staticImagePath: PropTypes.func
};

LX.propTypes = {
  trip: PropTypes.object,
  onRequest: PropTypes.func,
  messageLink: PropTypes.string,
};

export default LX;
